module.exports = __webpack_public_path__ + "static/media/ic-tab-inbox.09ec3853.png";